import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const InvoiceCreateModalUI = ({context, messageList, successMsg, errorList, setErrorList,
    // modes
    createMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
    // invoice name
    invoiceName, onInvoiceNameChange, invoiceNameError, setInvoiceNameError
  }) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_create_invoice'
    buttonMessageKey='c_create'
    cancelMessageKey='c_cancel'
    isOpen={createMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='invoiceName' required={true} maxLength={100}
      messageList={messageList} labelKey='c_invoice_name'
      value={invoiceName} onChange={onInvoiceNameChange}
      error={invoiceNameError} setError={setInvoiceNameError}
      autoFocus={true}
    />
  </ModalFormUI>

export default InvoiceCreateModalUI
